import React, {Component} from "react";
import {Form, Message} from "semantic-ui-react";
import MailchimpSubscribe from "react-mailchimp-subscribe"
import {Translate} from "react-localize-redux";
import PropTypes from "prop-types";

const url = "https://latentsignal.us18.list-manage.com/subscribe/post?u=b487e2dfc9b1f16aca92d9b91&amp;id=e5e8c415a1";

class MailingListForm extends Component {
  static propTypes = {
    mobile: PropTypes.bool.isRequired
  };

  state = { email: '', submittedEmail: '' };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleSubmit(subscribe) {
    const { email } = this.state;

    this.setState({ submittedEmail: email, email: '' });

    console.log(email);
    subscribe({
      EMAIL: email
    });
  };

  render() {
    const { email, submittedEmail } = this.state;

    return (
      <MailchimpSubscribe
        url={url}
        render={({ subscribe, status, message }) => (
          <Translate>
            {({translate}) => (
              <div>
                <Form onSubmit={this.handleSubmit.bind(this, subscribe)} loading={status === "sending"} success={status === "success"} error={status === "error"}>
                  <Form.Group>
                    <Form.Input
                      placeholder={translate("mailingList.email")}
                      name='email'
                      value={email}
                      type='email'
                      onChange={this.handleChange}
                      width={this.props.mobile ? 3: 14}
                    />
                    <Form.Button content={translate("mailingList.button")} width={4}/>
                  </Form.Group>
                  <Message success header={translate("mailingList.successHeader")} content={translate("mailingList.successMessage", { email: this.state.submittedEmail })}/>
                  <Message
                    error
                    header={translate("mailingList.errorHeader")}
                    content={<div dangerouslySetInnerHTML={{__html: message}}/>}
                  />
                </Form>
              </div>
              )}
          </Translate>
        )}
      />
    )
  }
}

export default MailingListForm



// WEBPACK FOOTER //
// ./src/components/mailinglist/MailingListForm.js